var render = function render(){var _vm=this,_c=_vm._self._c;return _c('project-info-panel',{attrs:{"load-data":_vm.loadDataFn,"card-bordered":_vm.cardBordered}})
}
var staticRenderFns = []

export { render, staticRenderFns }